import { DomSanitizer, SafeUrl } from "@angular/platform-browser"
import { APIService, ContentType } from "../../API.service"
import { Storage } from 'aws-amplify'
import { EventEmitter } from "@angular/core"
import { getContentSanitizedSrc, getSanitizedSrc } from "../../app.utilities";
import { v4 as uuid } from 'uuid'

export class ContentGridElement {

    id: string
    contentType: ContentType
    contentId?: string;
    contentValue?: string;
    src?: SafeUrl
    selected?: boolean
    deleting?: boolean
    reading?: boolean
    readProgress?: number
    uploading?: boolean
    storagePut?: any
    uploadProgress?: number
    sanitizer: DomSanitizer

    deleted: EventEmitter<string> = new EventEmitter<string>();
  
    constructor(type: ContentType, sanitizer: DomSanitizer, id: string = null,  contentId: string = null, contentValue: string = null, selected: boolean = false) {
     
      this.id = id;
      this.contentType = type;
      this.sanitizer = sanitizer;
      this.contentId = contentId;
      this.selected = selected;

      if (contentValue != null) {
        this.reading = this.contentType == ContentType.IMAGE || this.contentType == ContentType.VIDEO || this.contentType == ContentType.MODEL;       
        this.contentValue = contentValue;
        this.src = getSanitizedSrc(this.contentType, this.contentValue, this.sanitizer);
      }

      if (id == null) {

        if (this.contentId != null){
          this.id = contentId;
        } else {
          this.id = uuid();
        }

      }

    }

    setFile(api: APIService, institutionId, userId, file) {

      if (this.contentType == ContentType.IMAGE || this.contentType == ContentType.VIDEO || this.contentType == ContentType.MODEL){

        this.reading = true;
        this.uploading = true;
        this.uploadProgress = 0;

        var key = uuid();

        this.storagePut = Storage.put(
          key,
          file,
          {
            contentType: file.type,
            level: 'public',
            resumable: true,
            progressCallback: (progress) => {
              this.uploadProgress = (progress.loaded / progress.total) * 100
            },
            completeCallback: (event) => {
              api.CreateContent({
                contentInstitutionId: institutionId,
                contentUserId: userId,
                type: this.contentType,
                value: key
              }).then(createdContent => {
                this.contentId = createdContent.id;
                this.contentValue = createdContent.value;
                this.src = getContentSanitizedSrc(createdContent, this.sanitizer);
                this.reading = false;
                this.uploading = false;
              })
            }
          }
        )

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          var dataUrl = event.target.result as string;
          this.src = this.sanitizer.bypassSecurityTrustUrl(dataUrl);
        }
        reader.onprogress = (event) => {
          var progress = (event.loaded / event.total) * 100
          this.readProgress = progress;
        }

      }
    }

    cancelUpload(): void {
      this.reading = false;
      this.deleting = true;
      Storage.cancel(this.storagePut).then(() => {
        this.deleted.emit(this.id);
      })
    }

    delete(api: APIService) {

      if (confirm("Confirm Delete")) {
        this.deleting = true;
        api.DeleteContent({
          id: this.contentId
        }).then(() => {
          if (this.contentType == ContentType.IMAGE || this.contentType == ContentType.VIDEO || this.contentType == ContentType.MODEL) {
            Storage.remove(this.contentValue).then(() => {      
              this.deleted.emit(this.id);
            })
          } else {                 
            this.deleted.emit(this.id);
          }
        })
      }
      
    }
  
  }